import { defineComponent, h, nextTick } from 'vue';
import { throttle } from 'lodash';
import { QBtn, QIcon, QMenu, QCard, QCardSection, QCardActions, QTabs, QTab, QTabPanels, QTabPanel, QInput, QDialog } from 'quasar';
import PropertyGrid from './form/PropertyGrid2.jsx';
import AceEditor from './3rdParty/AceEditor.jsx';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';
import filters from '@/Shared/filters.js';
import api from '@/Services/api';
import TranslationContainer from './TranslationContainer.jsx';

import mitt from 'mitt';

import DocumentTreePanel from './DocumentTreePanel.jsx';
import ControlDesignerDockLayout from './ControlDesigner/controlDesignerDockLayout.vue';
import ControlDesignerDockSlot from './ControlDesigner/controlDesignerDockSlot.jsx';
import ControlDesignerJsonPanel from './ControlDesigner/controlDesignerJsonPanel.jsx';
import { resolveJsonCursorToModelNode, resolveModelNodeToJsonOffset } from './ControlDesigner/controlDesignerJsonCursorSync.js';
import ControlDesignerCodePanel from './ControlDesigner/controlDesignerCodePanel.jsx';
import ControlDesignerPropertiesPanel from './ControlDesigner/controlDesignerPropertiesPanel.jsx';
import {
    CODE_PANEL_ID,
    DESIGNER_PANEL_ID,
    DOCUMENT_TREE_PANEL_ID,
    DOCUMENT_USER_CONTROL,
    JSON_PANEL_ID,
    LEFT_TAB_GROUP_PANEL_IDS,
    PROPERTIES_PANEL_ID,
    activatePropertiesPanel,
    activateSiblingOfCodePanel,
    getCenterActivePanelId,
    getJsonTabGroup,
    getJsonTabGroupActivePanelId,
    getLeftActivePanelId,
    getLeftTabGroup,
    isCodePanelActive,
    isJsonTabActive,
    isPropertiesPanelActive,
} from './ControlDesigner/controlDesignerDockPanelRegistry.js';
import { resolveDesignerSelectionTarget, ensureModelObjectId } from './ControlDesigner/controlDesignerSelectionSync.js';
import {
    appendMethodToScopeScript,
    buildHandlerName,
    findMethodLineNumber,
    isDefaultScriptAction,
    parseMethodCall,
    scopeScriptHasMethod,
} from './ControlDesigner/controlDesignerScopeScript.js';
import {
    migrateLegacyScopeToScopeScript,
    isScopeScriptEmpty,
    shouldDeferScopeScriptInitialization,
} from './ControlDesigner/controlDesignerScopeScriptMigrate.js';

const EMPTY_ARRAY = Object.freeze([]);

function trackerEditsEqual(a, b) {
    if (a === b)
        return true;
    if (a == null || b == null)
        return a === b;
    return JSON.stringify(a) === JSON.stringify(b);
}

function formatDate(date) {
    var month = '' + (date.getMonth() + 1);
    var day = '' + date.getDate();
    var year = date.getFullYear();
    var hour = '' + date.getHours();
    if (hour.length == 1) hour = '0' + hour;
    var min = '' + date.getMinutes();
    if (min.length == 1) min = '0' + min;
    var sec = '' + date.getSeconds();
    if (sec.length == 1) sec = '0' + sec;

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('-') + ' ' + hour + ':' + min;
};
const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

const btnProps = {
    color: 'primary',
    size: 'sm',
    padding: 'none sm',
};

export default defineComponent({
    name: 'control-designer-v3',
    components: {
        QBtn,
        QIcon,
        QMenu,
        QCard,
        QCardSection,
        QCardActions,
        QDialog,
        QTabs,
        QTab,
        QTabPanels,
        QTabPanel,
        QInput,
        PropertyGrid,
        AceEditor,
        TranslationContainer,
        DocumentTreePanel,
        ControlDesignerDockLayout,
        ControlDesignerDockSlot,
        ControlDesignerJsonPanel,
        ControlDesignerCodePanel,
        ControlDesignerPropertiesPanel,
    },
    emits: ['reset-breadcrumb', 'finished-render'],
    data: function () {
        return {
            _uid: utils.generateUUID(),
            _events: mitt(),

            displayexpr: null,
            mode: null,
            viewdsgn: true,
            sourceurl: null,
            sourceraw: null,

            sel_schemaurl: null,
            sel_schemaraw: null,
            sel_modelurl: null,
            sel_modelvalue: null,
            sel_model: null,
            sel_schema: null,

            model: null,
            schema: null,
            selectednode: null,
            selectedmodel: null,
            ismodelselected: false,
            originalname: null,
            actions: [],
            externalactions: [],
            updatemodelactions: [],

            reset_breadcrumb: 0,
            can_autoreplace: false,
            forceOverwrite: false,
            modify_UserName: '',

            ControlURL: '',
            dynamicControl: '',
            type: '',
            designmodel: null,
            cData: null,
            history: [],

            temp_rawjson: '',
            rawjson_ischanged: false,

            save_in_progress: false,
            doc_revisions: [],
            doc_changes: [],
            max_months_history: 18,
            edits: null,
            editing_since: null,

            js_enabled: false,
            js_open: false,
            js_code: null,
            js_editor_height: 300,
            js_editor_width: 600,
            _jsEditorResizeObserver: null,
            _jsEditorResizeEl: null,
            js_editor_left: 175,
            hsm_errors_open: false,
            hsm_errors: [],

            UserControlSettingsOpen: false,
            UserControlSettingsTabs: 'one',
            userControlSettingsWidth: 800,
            userControlSettingsHeight: 700,
            _controlSettingsResizeObserver: null,
            _controlSettingsResizeEl: null,

            variablesSelection: '0',
            functionsSelection: '0',
            commandsSelection: '',

            treeHistory: [],
            tree_title: null,
            _lastSyncedPropertyNode: null,
            _syncingPropertyGrid: false,
            _syncingDesignerFromTree: false,
            _designerByModelId: null,
            _schemaCache: null,
            _defaultsApplied: null,
            currentSourceUrl: null,

            _dockviewApi: null,
            _dockRev: 0,
            _treePanelRef: null,
            _jsonTabGroupActivePanelId: null,
            _centerActivePanelId: null,
            _leftActivePanelId: null,
            _codePanelActive: false,
            _propertiesPanelActive: false,
            _jsonEditorMounted: false,
            _jsonEditorMountKey: 0,
            _scopeScriptMountKey: 0,
            _suppressJsonTabGroupActivePanelChange: false,
            _jsonTabGroupActiveDisposable: null,
            _boundJsonTabGroupId: null,
            _leftGroupActiveDisposable: null,
            _dockGlobalActiveDisposable: null,
            _legacyCodeBehindPromptOpen: false,
            _legacyCodeBehindPromptResolve: null,
        }
    },
    async created() {
        if (this.controlData.DisplayExpression)
            this.displayexpr = utils.compileExpression(this, this.controlData.DisplayExpression);

        if (this.controlData.SourceType === 'Url' && this.controlData.SourceUrl) {
            this.sourceurl = utils.compile(this, this.controlData.SourceUrl);

            this.$watch(
                function () {
                    return utils.evaluate(this.sourceurl, this);
                },
                function (val, oldval) {
                    console.log('ControlDesigner_v3 detected change in sourceurl; old:' + oldval + ', new:' + val + '; refreshing');
                    this.Refresh();
                    this.resetJsonTabState();
                    this.resetScopeScriptEditorState();
                    if (this.showDesignerDock)
                        this.activateDesignerTab();
                    else
                        this.activatePropertiesTab();
                }
            );
        }

        if (this.controlData.TreeTitle)
            this.tree_title = utils.compile(this, this.controlData.TreeTitle);

        this._throttledDockPanelBump = throttle(() => {
            this._dockPanelBumpNow();
        }, 50);

        //if (this.controlData.Actions)
        //    for (var i = 0; i < this.controlData.Actions.length; i++)
        //        this.actions.push(await utils.compileAction(this, this.controlData.Actions[i]));

        //if (this.controlData.ExternalActions)
        //    for (var i = 0; i < this.controlData.ExternalActions.length; i++)
        //        this.externalactions.push(await utils.compileAction(this, this.controlData.ExternalActions[i]));

        //if (this.controlData.UpdateModelActions)
        //    for (var i = 0; i < this.controlData.UpdateModelActions.length; i++)
        //        this.updatemodelactions.push(await utils.compileAction(this, this.controlData.UpdateModelActions[i]));

        // Trigger a function every 60 seconds to insure we keep the Redis tracking info up to date
        const tmp = this;
        this.timeoutReference = window.setTimeout(async () => {
            tmp.refreshTracking();
        }, 10 * 1000);

        this.$emit('finished-render', this);
        this._propertyGridForm = ['*'];
    },
    mounted() {
        this.Refresh();
        this.$nextTick(() => this._attachJsEditorResizeObserver());
    },
    beforeDestroy() {
        this.clearTracking();

        if (this.timeoutReference)
            window.clearTimeout(this.timeoutReference);

        this.timeoutReference = null;

        if (this._jsEditorResizeObserver && this._jsEditorResizeEl) {
            this._jsEditorResizeObserver.unobserve(this._jsEditorResizeEl);
            this._jsEditorResizeObserver = null;
            this._jsEditorResizeEl = null;
        }
        if (this._controlSettingsResizeObserver && this._controlSettingsResizeEl) {
            this._controlSettingsResizeObserver.unobserve(this._controlSettingsResizeEl);
            this._controlSettingsResizeObserver = null;
            this._controlSettingsResizeEl = null;
        }
        this._throttledDockPanelBump?.cancel?.();
        this._jsonTabGroupActiveDisposable?.dispose?.();
        this._jsonTabGroupActiveDisposable = null;
        this._leftGroupActiveDisposable?.dispose?.();
        this._leftGroupActiveDisposable = null;
        this._dockGlobalActiveDisposable?.dispose?.();
        this._dockGlobalActiveDisposable = null;
        this._dockviewApi = null;
        this._treePanelRef = null;
        this._jsonPanelRef = null;
        this._codePanelRef = null;
        if (this._legacyCodeBehindPromptResolve) {
            this._legacyCodeBehindPromptResolve(false);
            this._legacyCodeBehindPromptResolve = null;
        }
        this._legacyCodeBehindPromptOpen = false;
    },
    updated() {
        this._attachJsEditorResizeObserver();
        this._attachControlSettingsResizeObserver();
        this._throttledDockPanelBump?.();
    },
    computed: {
        Root: function () {
            return this.root;
        },
        Model: function () {
            return this.model;
        },
        SelectedNode: function () {
            return this.selectednode;
        },
        SelectedModel: function () {
            return this.selectedmodel;
        },
        hasNameChanged: function () {
            switch (this.mode) {
                case 'UserControl':
                case 'Action':
                case 'UserDefinedArea':
                    return this.model && (this.model.Name !== this.originalname);

                case 'MenuItem':
                    return this.model && this.model.MenuItemData && (this.model.MenuItemData.Title !== this.originalname);

                case 'Schema':
                    return this.model && (this.model.Namespace + '.' + this.model.Name) !== this.originalname;

                case 'Cassandra':
                    return this.model && (this.model.Keyspace !== this.originalname);

                default:
                    return false;
            }
        },
        modify_DateTime: function () {
            if (!this.model || !this.model.$Modify_DateTime)
                return '';

            const dt = new Date(Date.parse(this.model.$Modify_DateTime));
            return formatDate(dt);
        },
        showTree: function () {
            return this.controlData.ShowTree !== false;
        },
        showCode: function () {
            return this.model?.$typeSchema === DOCUMENT_USER_CONTROL;
        },
        legacyScopeMigrationPending: function () {
            return this.showCode && shouldDeferScopeScriptInitialization(this.model);
        },
        treeWidth: function () {
            const w = this.controlData.TreeWidth;
            return w ? parseInt(w, 10) : 300;
        },
        treeTitleDisplay: function () {
            if (this.tree_title) {
                try {
                    return utils.evaluate(this.tree_title, this);
                }
                catch (e) {
                    utils.warn('ControlDesigner_v3 TreeTitle failed to evaluate: ' + e);
                }
            }
            if (!this.model)
                return '';
            return this.model.Name || this.model.MenuItemData?.Title || this.model.title || 'Document';
        },
        showDesignerDock: function () {
            return this.viewdsgn && (this.mode != 'Schema' && this.mode != 'Cassandra');
        },
        jsonTabActive: function () {
            void this._dockRev;
            void this._jsonTabGroupActivePanelId;
            return isJsonTabActive(this._dockviewApi);
        },
        codeTabActive: function () {
            void this._dockRev;
            void this._codePanelActive;
            return this._codePanelActive === true;
        },
        propertiesTabActive: function () {
            void this._dockRev;
            void this._propertiesPanelActive;
            return this._propertiesPanelActive === true;
        },
    },
    methods: {
        ...methods,
        ...filters,
        async Refresh() {
            utils.log('Refresh');
            if (this.controlData.SourceType == 'Url' && this.sourceurl)
                try {
                    const url = utils.evaluate(this.sourceurl, this);
                    if (url) {
                        this.currentSourceUrl = url;
                        let apiRequest = {
                            method: 'GET',
                            url: url,
                            doNotUseWebsocket: true,
                            flatten: true
                        };
                        this.model = await api.apiRequest(apiRequest);
                    }
                }
                catch (e) {
                    utils.warn('ControlDesigner_v3 Source Url ' + this.controlData.SourceUrl + ' failed to evaluate: ' + e);
                }

            this.getTreePanelRef()?.clearExpansionState();
            this.editing_since = new Date();
            this.treeHistory = [];
            this.reset_breadcrumb = 0;
            this.save_in_progress = false;
            this.can_autoreplace = false;
            this.forceOverwrite = false;
            this.rawjson_ischanged = false;
            this.resetScopeScriptEditorState();
            this.modelHasChanged();
            try {
                this.fullName = await utils.api.get('Apps/User/FullName');
            }
            catch (e) {
                utils.log('Apps/User/FullName failed: ' + e);
            }
            if (!this.fullName) this.fullName = 'Query Error';
        },
        applySchemaDefaultsToModel() {
            if (this.sel_schema && this.sel_model) {
                if (this._defaultsApplied?.has(this.sel_model))
                    return;

                const resolved = utils.schema.resolve_Of(this.sel_schema);

                for (var key in resolved.properties) {
                    const element = resolved.properties[key];

                    if (('default' in element) && !(key in this.sel_model)) {
                        this.sel_model[key] = element['default'];
                    }
                    else if (element.type === 'object' && !(key in this.sel_model)) {
                        const model = utils.schema.getDefaultModel(element);
                        this.sel_model[key] = model;
                    }
                }

                if (!this._defaultsApplied)
                    this._defaultsApplied = new WeakSet();
                this._defaultsApplied.add(this.sel_model);
            }
        },
        async syncPropertyGridFromTreeNode(node) {
            if (this._syncingPropertyGrid)
                return;
            if (node === this._lastSyncedPropertyNode)
                return;

            this._syncingPropertyGrid = true;
            try {
                this._lastSyncedPropertyNode = node;

                if (node?.$typeSchema) {
                    if (!this._schemaCache)
                        this._schemaCache = Object.create(null);

                    let schema = this._schemaCache[node.$typeSchema];
                    if (!schema) {
                        try {
                            schema = await utils.schema.get(node.$typeSchema);
                            if (schema)
                                this._schemaCache[node.$typeSchema] = schema;
                        }
                        catch (e) {
                            utils.warn('ControlDesigner_v3 syncPropertyGridFromTreeNode schema load failed: ' + e);
                            schema = null;
                        }
                    }

                    if (node && !node.$objectId)
                        ensureModelObjectId(node);

                    this.sel_model = node;
                    this.sel_schema = schema;
                    this.applySchemaDefaultsToModel();
                }
                else {
                    this.sel_schema = null;
                    this.sel_model = node ?? {};
                }

                utils.executeAndCompileAllActions(this.controlData.Actions || [], { SelectedModel: node }, this);
            }
            finally {
                this._syncingPropertyGrid = false;
            }
        },
        onTreeNodeSelected(node) {
            this.syncJsonCursorFromTreeNode(node);
            if (node === this._lastSyncedPropertyNode)
                return;
            void this.syncSelectionFromTree(node);
        },
        syncJsonCursorFromTreeNode(node) {
            if (!node || !this.jsonTabActive)
                return;
            if (!this._jsonPanelRef?.isFollowOutlineEnabled?.())
                return;

            const offset = resolveModelNodeToJsonOffset(this.temp_rawjson, node, this.model);
            if (offset != null)
                this._jsonPanelRef.navigateToOffset(offset);
        },
        async syncSelectionFromTree(node) {
            await this.syncPropertyGridFromTreeNode(node);

            if (!node?.$typeSchema)
                return;

            let target = this.resolveDesignerSelectionTarget(node);
            if (!target) {
                await nextTick();
                target = this.resolveDesignerSelectionTarget(node);
            }
            if (!target)
                return;

            this._syncingDesignerFromTree = true;
            try {
                this.SelectNode(target.host, target.model);
            }
            finally {
                this._syncingDesignerFromTree = false;
            }
        },
        resolveDesignerSelectionTarget(node) {
            return resolveDesignerSelectionTarget(this, node);
        },
        registerDesignerComponent(component) {
            const model = component?.designmodel;
            if (!model || typeof model !== 'object')
                return;

            ensureModelObjectId(model);

            if (!this._designerByModelId)
                this._designerByModelId = new Map();
            if (!this._designerByModelRef)
                this._designerByModelRef = new WeakMap();
            if (!this._designerComponents)
                this._designerComponents = new Set();

            const id = model.$objectId;
            const prev = this._designerByModelId.get(id);
            if (prev && prev !== component)
                this._designerComponents.delete(prev);

            this._designerByModelId.set(id, component);
            this._designerByModelRef.set(model, component);
            this._designerComponents.add(component);
        },
        unregisterDesignerComponent(component) {
            const model = component?.designmodel;
            if (!this._designerByModelId || !model)
                return;

            this._designerComponents?.delete(component);

            if (this._designerByModelRef?.get(model) === component)
                this._designerByModelRef.delete(model);

            const id = model.$objectId;
            if (id && this._designerByModelId.get(id) === component)
                this._designerByModelId.delete(id);
        },
        async navigateTreeBack() {
            if (this.treeHistory.length > 0) {
                const last = this.treeHistory[this.treeHistory.length - 1];
                this.treeHistory.splice(this.treeHistory.length - 1);
                await this.ExternalNavigate(last, { skipHistoryPush: true });
            }
        },
        syncTreeSelection(node, expand) {
            this.getTreePanelRef()?.setSelectedNode(node, expand, !!expand);
        },
        nameHasChanged() {
            switch (this.mode) {
                case 'UserControl':
                case 'Action':
                case 'UserDefinedArea':
                    this.originalname = this.model ? this.model.Name : '';
                    break;
                case 'MenuItem':
                    this.originalname = this.model ? this.model.MenuItemData.Title : '';
                    break;
                case 'Schema':
                    this.originalname = this.model ? (this.model.Namespace + '.' + this.model.Name) : '';
                    break;
                case 'Cassandra':
                    this.originalname = this.model ? this.model.Keyspace : '';
                    break;
            }
            this.editing_since = new Date();
        },
        modelHasChanged() {
            if (this.model)
                switch (this.model.$typeSchema) {
                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserControl":
                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserControlTest":this.mode = 'UserControl'; break;
                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserAction": this.mode = 'Action'; break;
                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserDefinedArea": this.mode = 'UserDefinedArea'; break;
                    case "/schema/public/Platform.Schema.Documents.v1/Document_CareCenterMenuItem":
                    case "/schema/public/Platform.Schema.Documents.v1/Document_CareCenterMenuChildMenuItem":
                    case "/schema/public/Platform.Schema.Documents.v1/Document_CareCenterMenuPopupMenuItem":
                    case "/schema/public/Platform.Schema.Documents.v1/Document_BackgroundServices":
                        this.mode = 'MenuItem';
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_Schema": this.mode = "Schema"; break;
                    case "/schema/public/Platform.Schema.Documents.v1/Document_CassandraKeyspace": this.mode = "Cassandra"; break;

                    default:
                        if ('ControlType' in this.model)
                            this.mode = 'UserControl';
                        else
                            this.mode = 'Unknown';
                        break;
                }

            this.loadDocRevisions();
            this.nameHasChanged();
            this.modelDataHasChanged();
            this.ensureScopeScript();
            this.ensureScopeIncludes();
            if (this.model)
                this.readModifyUserName();

            this.selectednode = null;
            this.selectedmodel = null;
            this.ismodelselected = false;
            this._lastSyncedPropertyNode = null;
            this._designerByModelId = null;
            this._designerByModelRef = null;
            this._designerComponents = null;
            this._schemaCache = null;
            this._defaultsApplied = null;
            this.sel_schema = null;
            this.sel_model = null;
            this.history = [];

            utils.executeAndCompileAllActions(this.controlData.Actions || [], { SelectedModel: this.selectedmodel }, this);
            //for (var i = 0; i < this.actions.length; i++)
            //    utils.executeAction(this.actions[i], null, this);
        },
        modelDataHasChanged() {
            if (this.modelData_watch$) {
                this.modelData_watch$(); // Release watch
                this.modelData_watch$ = null;
            }

            if (this.model) {
                switch (this.model.$typeSchema) {
                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserControl":
                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserControlTest":
                        this.dynamicControl = utils.getDynamicComponent(null, this.model.Data, null, true);
                        this.type = this.model.Data.ControlType;
                        this.designmodel = this.model.Data;
                        this.cData = this.model.Data.ControlData;
                        // Monitor the Data because this isn't watched anywhere else
                        this.modelData_watch$ = this.$watch(
                            function () {
                                return this.model.Data;
                            },
                            function (val, oldval) {
                                utils.log('modelData_watch$ fired for UserControl');
                                this.modelDataHasChanged();
                            });
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserAction":
                        this.dynamicControl = utils.getDynamicAction(this.model.Data);
                        if (this.dynamicControl) {
                            this.type = this.model.Data.ActionType;
                            this.designmodel = this.model.Data;
                            this.cData = this.model.Data.ActionData;                            
                        }
                        else {
                            this.type = this.model.Data.ActionType; // 'Unknown';
                            this.designmodel = this.model.Data;
                            this.cData = this.model.Data.ActionData ? this.model.Data.ActionData : this.model.Data;
                        }
                        // Monitor the Data because this isn't watched anywhere else
                        this.modelData_watch$ = this.$watch(
                            function () {
                                return this.model.Data;
                            },
                            function (val, oldval) {
                                utils.log('modelData_watch$ fired for UserAction');
                                this.modelDataHasChanged();
                            });
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_UserDefinedArea":
                        this.dynamicControl = 'stack-vertical';
                        this.type = 'VerticalStack';
                        this.designmodel = this.model;
                        this.cData = this.model;
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_CareCenterMenuPopupMenuItem":
                        this.dynamicControl = 'carecenter-popupmenu';
                        this.type = this.model.MenuItemType;
                        this.designmodel = this.model;
                        this.cData = this.model.MenuItemData;
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_CareCenterMenuItem":
                    case "/schema/public/Platform.Schema.Documents.v1/Document_CareCenterMenuChildMenuItem":
                        this.dynamicControl = 'carecenter-menu';
                        this.type = this.model.MenuItemType;
                        this.designmodel = this.model;
                        this.cData = this.model.MenuItemData.ControlData;
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_BackgroundServices":
                        this.dynamicControl = 'background-service';
                        this.type = this.model.MenuItemType;
                        this.designmodel = this.model;
                        this.cData = this.model.MenuItemData;
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_Schema":
                        this.type = 'Unknown';
                        this.designmodel = null;
                        this.cData = null;
                        break;

                    case "/schema/public/Platform.Schema.Documents.v1/Document_CassandraKeyspace":
                        this.type = 'Unknown';
                        this.designmodel = null;
                        this.cData = null;
                        break;

                    default:
                        if ('ControlType' in this.model) {
                            this.dynamicControl = utils.getDynamicComponent(null, this.model, null, true);
                            this.type = this.model.ControlType;
                            this.designmodel = this.model;
                            this.cData = this.model.ControlData;
                        }
                        else {
                            this.type = 'Unknown';
                            this.designmodel = this.model;
                            this.cData = this.model.Data ? this.model.Data.ControlData : {};
                        }
                        break;
                }

                if (!this.dynamicControl)
                    this.dynamicControl = 'default-unknown';

                this.dynamicControl += '-dsgn';
            }
        },
        async readModifyUserName() {
            if (this.model.$Modify_UserID) {
                const uri = 'Apps/Common/UserInfo/' + this.model.$Modify_UserID;
                const res = await utils.api.get(uri);

                this.modify_UserName = res.FullName;
            }
            else
                this.modify_UserName = '';
        },
        sync(prop, value) {
            let model = this.model;
            if (prop.includes('.')) {
                const parts = prop.split('.');
                for (let i = 0; i < parts.length - 1; i++)
                    model = model[parts[i]];

                model[parts[parts.length - 1]] = value;
            }
            else
                model[prop] = value;
        },
        syncSchemaName(value) {
            let newname = value;
            let newns = '';
            const idx = newname.lastIndexOf('.');
            if (idx >= 0) {
                newns = newname.substr(0, idx);
                newname = newname.substr(idx + 1);
            }
            this.model['Namespace'] = newns;
            this.model['Name'] = newname;
        },
        async saveKeyspace() {
            const uri = 'Apps/Raw/CassandraKeyspace';

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            this.save_in_progress = true;
            const data = utils.cleanModel(this.model);
            const res = await utils.api.request('POST', uri, data, false, true);
            this.save_in_progress = false;

            if (res.Result) {
                // Update these so we can save again
                this.model._id = res.Output.Id;
                this.model._rev = res.Output.Rev;
                this.nameHasChanged();
                this.loadDocRevisions();
            }
            else
                alert("Could not save! " + JSON.stringify(res, null, 4));
        },
        async saveKeyspaceAsNew() {
            const uri = 'Apps/Raw/CassandraKeyspace';

            const old_id = this.model._id;
            const old_rev = this.model._rev;

            delete this.model['_id'];
            delete this.model['_rev'];

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            try {
                this.save_in_progress = true;
                const res = await utils.api.request('POST', uri, utils.cleanModel(this.model), false, true);
                this.save_in_progress = false;

                if (res.Result) {
                    // Update these so we can save again
                    this.model._id = res.Output.Id;
                    this.model._rev = res.Output.Rev;
                    this.nameHasChanged();
                    this.doc_revisions = [];
                }
                else {
                    // Restore these so we can save again
                    this.model._id = old_id;
                    this.model._rev = old_rev;

                    alert("Could not save! " + JSON.stringify(res, null, 4));
                }
            }
            catch (e) {
                // Restore these so we can save again
                this.model._id = old_id;
                this.model._rev = old_rev;

                alert("Error saving: " + e);
                this.save_in_progress = false;
            }
        },
        async saveUserControl(type, autoReplace) {
            if (!this.ensureRawJsonAppliedBeforeSave())
                return;

            let rev;
            let uri = 'Apps/Raw/UI/' + (type || 'UserControl');
            if (autoReplace) {
                uri += '?AutoReplace=' + (autoReplace ? 'true' : 'false');
                rev = this.model._rev;
                delete this.model['_rev'];
            }

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            this.save_in_progress = true;
            const data = utils.cleanModel(this.model);
            let res;
            try {
                res = await utils.api.request('POST', uri, data, false, true);
            }
            catch (e) {
                alert(`${JSON.stringify(e, null, 4)}`);
            }
            finally {
                this.save_in_progress = false;
            }

            if (res && res.Result) {
                //alert('Saved! ' + JSON.stringify(res, null, 4));

                // Update these so we can save again
                this.model._id = res.Output.Id;
                this.model._rev = res.Output.Rev;
                this.forceOverwrite = false;
                this.can_autoreplace = false;
                this.originalname = this.model.Name;
                this.loadDocRevisions();
            }
            else {
                alert("Could not save! " + JSON.stringify(res, null, 4));

                if (rev)
                    this.model._rev = rev;

                if (res && res.Output && res.Output.StatusCode == 409) // 409 : Conflict
                    this.can_autoreplace = true;
            }
        },
        async saveMenuItem(autoReplace) {
            if (!this.ensureRawJsonAppliedBeforeSave())
                return;

            // POST, URL: https://api-dev1.callcorplab.com/Apps/Raw/UI/MenuItem
            let rev;
            let uri = 'Apps/Raw/UI/MenuItem';
            if (autoReplace) {
                uri += '?AutoReplace=' + (autoReplace ? 'true' : 'false');
                rev = this.model._rev;
                delete this.model['_rev'];
            }

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            this.save_in_progress = true;
            const data = utils.cleanModel(this.model);
            const res = await utils.api.request('POST', uri, data, false, true);
            this.save_in_progress = false;

            if (res.Result) {
                //alert('Saved! ' + JSON.stringify(res, null, 4));

                // Update these so we can save again
                this.model._id = res.Output.Id;
                this.model._rev = res.Output.Rev;
                this.forceOverwrite = false;
                this.can_autoreplace = false;
                this.originalname = this.model.MenuItemData.Title;
                this.loadDocRevisions();
            }
            else {
                alert("Could not save! " + JSON.stringify(res, null, 4));

                if (rev)
                    this.model._rev = rev;

                if (res.Output.StatusCode == 409) // 409 : Conflict
                    this.can_autoreplace = true;
            }
        },
        async saveSchema() {
            if (!this.ensureRawJsonAppliedBeforeSave())
                return;

            const uri = 'Apps/Raw/Schema';

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            this.save_in_progress = true;
            const data = utils.cleanModel(this.model);
            let res;
            try {
                res = await utils.api.request('POST', uri, data, false, true);
            }
            catch (e) {
                alert(`${JSON.stringify(e, null, 4)}`);
            }
            finally {
                this.save_in_progress = false;
            }

            if (res && res.Result) {
                // Update these so we can save again
                this.model._id = res.Output.Id;
                this.model._rev = res.Output.Rev;
                this.originalname = this.model.Namespace + '.' + this.model.Name;
                this.loadDocRevisions();
            }
            else
                alert("Could not save! " + JSON.stringify(res, null, 4));
        },
        async saveUserControlAsNew(type) {
            if (!this.ensureRawJsonAppliedBeforeSave())
                return;

            const uri = 'Apps/Raw/UI/' + (type || 'UserControl');

            const old_id = this.model._id;
            const old_rev = this.model._rev;

            delete this.model['_id'];
            delete this.model['_rev'];

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            this.save_in_progress = true;
            const res = await utils.api.request('POST', uri, utils.cleanModel(this.model), false, true);
            this.save_in_progress = false;

            if (res.Result) {
                // Update these so we can save again
                this.model._id = res.Output.Id;
                this.model._rev = res.Output.Rev;
                this.nameHasChanged();

                //alert('Saved as New! ' + JSON.stringify(res, null, 4));
                this.doc_revisions = [];
            }
            else {
                // Restore these so we can save again
                this.model._id = old_id;
                this.model._rev = old_rev;

                alert("Could not save! " + JSON.stringify(res, null, 4));
            }
        },
        async saveMenuItemAsNew() {
            if (!this.ensureRawJsonAppliedBeforeSave())
                return;

            const uri = 'Apps/Raw/UI/MenuItem';

            const old_id = this.model._id;
            const old_rev = this.model._rev;

            delete this.model['_id'];
            delete this.model['_rev'];

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            this.save_in_progress = true;
            const res = await utils.api.request('POST', uri, utils.cleanModel(this.model), false, true);
            this.save_in_progress = false;

            if (res.Result) {
                // Update these so we can save again
                this.model._id = res.Output.Id;
                this.model._rev = res.Output.Rev;
                this.nameHasChanged();

                //alert('Saved as New! ' + JSON.stringify(res, null, 4));
                this.doc_revisions = [];
            }
            else {
                // Restore these so we can save again
                this.model._id = old_id;
                this.model._rev = old_rev;

                alert("Could not save! " + JSON.stringify(res, null, 4));
            }
        },
        async saveSchemaAsNew() {
            if (!this.ensureRawJsonAppliedBeforeSave())
                return;

            const uri = 'Apps/Raw/Schema';

            const old_id = this.model._id;
            const old_rev = this.model._rev;

            delete this.model['_id'];
            delete this.model['_rev'];

            if (this.model.$DeployID == 'sync') this.model.$DeployID = 'dev';

            try {
                this.save_in_progress = true;
                const res = await utils.api.request('POST', uri, utils.cleanModel(this.model), false, true);
                this.save_in_progress = false;

                if (res.Result) {
                    // Update these so we can save again
                    this.model._id = res.Output.Id;
                    this.model._rev = res.Output.Rev;
                    this.nameHasChanged();
                    this.doc_revisions = [];
                }
                else {
                    // Restore these so we can save again
                    this.model._id = old_id;
                    this.model._rev = old_rev;

                    alert("Could not save! " + JSON.stringify(res, null, 4));
                }
            }
            catch (e) {
                // Restore these so we can save again
                this.model._id = old_id;
                this.model._rev = old_rev;

                alert("Error saving: " + e);
                this.save_in_progress = false;
            }
        },
        async saveExtractedEntity(type, newmodel) {
            const uri = 'Apps/Raw/UI/' + (type || 'UserControl');

            this.save_in_progress = true;
            const res = await utils.api.request('POST', uri, utils.cleanModel(newmodel), false, true);
            this.save_in_progress = false;

            if (!res.Result) {
                alert("Could not save! " + JSON.stringify(res, null, 4));
            }
            return res.Result;
        },
        selectNodeInternal(node, model) {
            const targetModel = model || node?.designmodel || node;
            this.selectednode = node;
            this.selectedmodel = targetModel;
            this.ismodelselected = !!this.selectedmodel;

            this.syncTreeSelection(targetModel, true);
            this.syncPropertyGridFromTreeNode(targetModel);

            if (model && node && node.designmodel) {
                let dynamicControl; // = utils.getDynamicHelperControl(node.designmodel.ControlType, model);
                if (node.designmodel.ControlType == 'BasicPopupMenu' || node.designmodel.ControlType == 'IconPopupMenu')
                    dynamicControl = utils.getDynamicComponent(null, model, null, true); // Ask for nameonly to prevent it returning the actual Vue component

                if (dynamicControl) {
                    this.history.push({
                        dynamicControl: this.dynamicControl,
                        type: this.type,
                        designmodel: this.designmodel,
                        cData: this.cData,
                    });

                    dynamicControl += '-dsgn';

                    this.dynamicControl = dynamicControl;
                    this.type = model.ControlType;
                    this.designmodel = model;
                    this.cData = model.ControlData;
                    return;
                }
            }

            if (model && model.$typeSchema && model.$typeSchema.includes('/schema/public/Platform.Schema.UIActions.v1/UIAction_')) {
                let dynamicAction = utils.getDynamicAction(model);
                if (!dynamicAction)
                    return;

                this.history.push({
                    dynamicControl: this.dynamicControl,
                    type: this.type,
                    designmodel: this.designmodel,
                    cData: this.cData,
                });

                dynamicAction += '-dsgn';

                this.dynamicControl = dynamicAction; // 'stack-vertical-dsgn';
                this.type = model.ActionType;
                this.designmodel = model;
                this.cData = model.ActionData;
            }
        },
        SelectNode(node, model) {
            const targetModel = model || node?.designmodel || node;
            this.selectednode = node;
            this.selectedmodel = targetModel;
            this.ismodelselected = !!this.selectedmodel;

            this.syncTreeSelection(targetModel, true);
            this.syncPropertyGridFromTreeNode(targetModel);

            this.$emitself('reset-breadcrumb');
        },
        async ExternalNavigate(url, options) {
            const opts = options || {};
            utils.log('ControlDesigner_v3.ExternalNavigate(url:' + url + ')');
            this.ControlURL = url;

            if (!opts.skipHistoryPush && this.currentSourceUrl)
                this.treeHistory.push(this.currentSourceUrl);

            this.getTreePanelRef()?.clearExpansionState();

            try {
                let apiRequest = {
                    method: 'GET',
                    url: url,
                    doNotUseWebsocket: true,
                    flatten: true
                };
                this.model = await api.apiRequest(apiRequest);
                this.currentSourceUrl = url;
                this.modelHasChanged();
            }
            catch (e) {
                utils.warn('ControlDesigner_v3 ExternalNavigate failed: ' + e);
            }

            utils.executeAndCompileAllActions(this.controlData.ExternalActions, { ControlURL: url }, this);
        },
        ExternalNavigateToName(type, name) {
            utils.executeAndCompileAllActions(this.controlData.OpenExternalActions, { Type: type, Name: name }, this);
        },
        navigateUp() {
            if (this.selectednode && typeof this.selectednode === 'object') {
                //let p = this.selectednode.Parent;
                let p = this.selectednode.$parent;

                // Look for a parent object that is a CallCorp control (skip native vue controls)
                while (p && (!p.root || (p.type == 'VerticalLayout' && !p.is_vstack_parent))) {
                    if (p.$attrs && 'c_context' in p.$attrs)
                        p = p.$attrs.c_context;
                    else
                        p = p.$parent;
                }

                if (p)
                    this.selectNodeInternal(p);
            }
        },
        navigateToModel(value) {
            this.selectNodeInternal(this.selectednode, value);
        },
        getTreePanelRef() {
            return this._treePanelRef ?? this.$refs.treePanel;
        },
        _dockPanelBumpNow() {
            const api = this._dockviewApi;
            if (!api?.panels?.length)
                return;
            this._centerActivePanelId = getCenterActivePanelId(api);
            this._jsonTabGroupActivePanelId = getJsonTabGroupActivePanelId(api);
            this._leftActivePanelId = getLeftActivePanelId(api);
            this._codePanelActive = isCodePanelActive(api);
            this._propertiesPanelActive = isPropertiesPanelActive(api);
            this._dockRev = (this._dockRev || 0) + 1;
            const bump = {
                _dockRev: this._dockRev,
                _centerActivePanelId: this._centerActivePanelId,
                _jsonTabActive: isJsonTabActive(api),
                _jsonTabGroupActivePanelId: this._jsonTabGroupActivePanelId,
                _leftActivePanelId: this._leftActivePanelId,
                _codeTabActive: this._codePanelActive,
                _propertiesTabActive: this._propertiesPanelActive,
            };
            for (const p of api.panels)
                p.update({ params: bump });

            const jsonGroupId = getJsonTabGroup(api)?.id ?? null;
            if (jsonGroupId !== this._boundJsonTabGroupId) {
                this._boundJsonTabGroupId = jsonGroupId;
                this.bindJsonTabTracking(api);
            }
        },
        bindLeftTabTracking(api) {
            this._leftGroupActiveDisposable?.dispose?.();
            this._leftGroupActiveDisposable = null;

            const leftGroup = getLeftTabGroup(api);
            if (leftGroup?.api?.onDidActivePanelChange) {
                this._leftGroupActiveDisposable = leftGroup.api.onDidActivePanelChange((event) => {
                    const id = event?.panel?.id;
                    if (id && LEFT_TAB_GROUP_PANEL_IDS.has(id)) {
                        this._leftActivePanelId = id;
                        this._dockPanelBumpNow();
                    }
                });
            }
        },
        ensureScopeScript() {
            if (!this.showCode || !this.model)
                return;
            if (shouldDeferScopeScriptInitialization(this.model)) {
                if ('ScopeScript' in this.model && isScopeScriptEmpty(this.model.ScopeScript))
                    delete this.model.ScopeScript;
                return;
            }
            if (isScopeScriptEmpty(this.model.ScopeScript) || !('ScopeScript' in this.model))
                this.model.ScopeScript = '({\n\t// Define variables and functions as members\n\t// of a single JavaScript object. Reference\n\t// Control to access members of the document.\n\tdemo1: \'Hello world\',\n\tdemo() {\n\t\treturn this.demo1;\n\t},\n})';
        },
        ensureScopeIncludes() {
            if (!this.showCode || !this.model)
                return;
            if (!Array.isArray(this.model.ScopeIncludes))
                this.model.ScopeIncludes = [];
        },
        onScopeScriptChanged(text, options = {}) {
            if (!this.model)
                return;
            if (!options.force && shouldDeferScopeScriptInitialization(this.model))
                return;
            this.model.ScopeScript = text;
        },
        onScopeIncludesChanged(includes) {
            if (!this.model)
                return;
            const next = Array.isArray(includes) ? includes : [];
            if (next.length === 0) {
                if ('ScopeIncludes' in this.model)
                    delete this.model.ScopeIncludes;
                return;
            }
            this.model.ScopeIncludes = next;
        },
        onScopePublicChanged(names) {
            if (!this.model)
                return;
            const next = Array.isArray(names) ? names : [];
            if (next.length === 0) {
                if ('ScopePublic' in this.model)
                    delete this.model.ScopePublic;
                return;
            }
            this.model.ScopePublic = next;
        },
        onMigrateLegacyScope() {
            if (!this.model)
                return;

            const result = migrateLegacyScopeToScopeScript({
                variables: this.model.Variables || [],
                functions: this.model.Functions || [],
                scopeScript: this.model.ScopeScript || '',
                scopePublic: this.model.ScopePublic || [],
            });

            if (result.migrated.length === 0 && result.skipped.length === 0)
                return;

            const summary = [
                `Migrate ${result.migrated.length} member(s) into ScopeScript?`,
                result.migrated.length ? `Add: ${result.migrated.join(', ')}` : '',
                result.skipped.length ? `Skip: ${result.skipped.map((item) => item.name).join(', ')}` : '',
            ].filter(Boolean).join('\n');

            if (!window.confirm(summary))
                return;

            this.model.ScopeScript = result.scopeScript;
            this.onScopePublicChanged(result.scopePublic);
            this.resetScopeScriptEditorState();
        },
        _addOrNavigateScopeScriptMethod(methodName, methodBlock) {
            if (!this.model)
                return;

            this.ensureScopeScript();

            let scopeScript = this.model.ScopeScript || '';
            if (!scopeScriptHasMethod(scopeScript, methodName)) {
                scopeScript = appendMethodToScopeScript(scopeScript, methodBlock);
                this.onScopeScriptChanged(scopeScript, { force: true });
            }

            this.openCodeTab();

            const line = findMethodLineNumber(this.model.ScopeScript || scopeScript, methodName);
            if (line != null)
                this.navigateScopeScriptToLine(line);
        },
        addOnCreated() {
            this._addOrNavigateScopeScriptMethod(
                'onCreated',
                '\tasync onCreated() {\n\t\t// Runs before content is mounted\n\t}',
            );
        },
        addOnMounted() {
            this._addOrNavigateScopeScriptMethod(
                'onMounted',
                '\tasync onMounted() {\n\t\t// Runs after the control tree has rendered\n\t}',
            );
        },
        resetScopeScriptEditorState() {
            this._scopeScriptMountKey = (this._scopeScriptMountKey || 0) + 1;
        },
        openCodeTab() {
            const panel = this._dockviewApi?.getPanel(CODE_PANEL_ID);
            if (!panel?.api?.setActive)
                return;
            this.ensureScopeScript();
            this.ensureScopeIncludes();
            panel.api.setActive();
            this.$nextTick(() => {
                const leftId = getLeftActivePanelId(this._dockviewApi);
                if (leftId === CODE_PANEL_ID) {
                    this._leftActivePanelId = CODE_PANEL_ID;
                    this._dockPanelBumpNow();
                }
            });
        },
        navigateScopeScriptToLine(line, column) {
            this._codePanelRef?.navigateToLine?.(line, column);
        },
        _isUsableCodeBehindControlName(name) {
            return !!(name && String(name).trim() !== '' && name !== 'Unnamed');
        },
        _findScriptActionInList(actions, matchScriptAction) {
            const match = matchScriptAction || isDefaultScriptAction;
            if (!Array.isArray(actions))
                return null;
            for (let i = 0; i < actions.length; i++) {
                if (match(actions[i]))
                    return actions[i];
            }
            return null;
        },
        async _createScriptActionModel(actionTypeSchema, methodName) {
            try {
                const schema_ = await utils.schema.get(actionTypeSchema);
                const schema = utils.schema.resolve_Of(schema_);
                const action = utils.schema.getDefaultModel(schema);
                if (!action.ActionData)
                    action.ActionData = {};
                action.ActionData.Method = methodName;
                return action;
            }
            catch (e) {
                utils.warn('ControlDesigner_v3: could not load action schema, using fallback Script action: ' + e);
                return {
                    $typeSchema: actionTypeSchema,
                    PrimitiveAction: true,
                    ActionType: 'Script',
                    RunAsync: false,
                    ActionData: {
                        Method: methodName,
                        Debug: {
                            $typeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Debug',
                            BreakPoint: false,
                        },
                    },
                    $objectId: utils.generateUUID(),
                };
            }
        },
        openCodeBehind(component, config) {
            if (!this.showCode || !component || !config)
                return;

            const designmodel = component.designmodel;
            const controlData = component.controlData;
            if (!designmodel || !controlData)
                return;

            const controlName = designmodel.ControlData.Name;
            if (!this._isUsableCodeBehindControlName(controlName)) {
                alert('Assign a Name to this control in Properties before wiring code-behind.');
                return;
            }

            if (shouldDeferScopeScriptInitialization(this.model)) {
                void this.confirmLegacyCodeBehind().then((proceed) => {
                    if (!proceed)
                        return;
                    void this._completeOpenCodeBehind(component, config, designmodel, controlData, controlName);
                });
                return;
            }

            void this._completeOpenCodeBehind(component, config, designmodel, controlData, controlName);
        },
        confirmLegacyCodeBehind() {
            return new Promise((resolve) => {
                this._legacyCodeBehindPromptResolve = resolve;
                this._legacyCodeBehindPromptOpen = true;
            });
        },
        onLegacyCodeBehindPromptProceed() {
            this._legacyCodeBehindPromptOpen = false;
            const resolve = this._legacyCodeBehindPromptResolve;
            this._legacyCodeBehindPromptResolve = null;
            resolve?.(true);
        },
        onLegacyCodeBehindPromptCancel() {
            this._legacyCodeBehindPromptOpen = false;
            const resolve = this._legacyCodeBehindPromptResolve;
            this._legacyCodeBehindPromptResolve = null;
            resolve?.(false);
        },
        renderLegacyCodeBehindPrompt() {
            return (
                <QDialog
                    modelValue={this._legacyCodeBehindPromptOpen}
                    onUpdate:modelValue={(open) => {
                        if (!open)
                            this.onLegacyCodeBehindPromptCancel();
                    }}
                    persistent
                >
                    <QCard style={{ minWidth: '360px', maxWidth: '480px' }}>
                        <QCardSection>
                            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Legacy scope in use</div>
                            <div>
                                This document uses legacy Variables and/or Functions. Creating ScopeScript before migrating may change how scope members resolve at runtime. Proceed anyway?
                            </div>
                        </QCardSection>
                        <QCardActions align="right">
                            <QBtn flat label="Cancel" onClick={() => this.onLegacyCodeBehindPromptCancel()} />
                            <QBtn flat color="primary" label="Proceed" onClick={() => this.onLegacyCodeBehindPromptProceed()} />
                        </QCardActions>
                    </QCard>
                </QDialog>
            );
        },
        async _completeOpenCodeBehind(component, config, designmodel, controlData, controlName) {
            this.SelectNode(component);

            const actionsKey = config.actionsKey || 'Actions';
            if (!controlData[actionsKey])
                controlData[actionsKey] = [];

            const matchScriptAction = config.matchScriptAction || isDefaultScriptAction;
            let existingAction = this._findScriptActionInList(controlData[actionsKey], matchScriptAction);

            const defaultHandlerName = buildHandlerName(controlName, config.handlerSuffix || '');
            let handlerName = defaultHandlerName;

            if (existingAction?.ActionData?.Method) {
                const parsed = parseMethodCall(existingAction.ActionData.Method);
                if (parsed)
                    handlerName = parsed;
            }

            const buildActionMethod = config.buildActionMethod || ((name) => name);
            const methodName = buildActionMethod(handlerName);

            if (!existingAction) {
                existingAction = await this._createScriptActionModel(config.actionTypeSchema, methodName);
                controlData[actionsKey].push(existingAction);
            }
            else if (existingAction.ActionData && !existingAction.ActionData.Method) {
                existingAction.ActionData.Method = methodName;
            }

            this.ensureScopeScript();

            let scopeScript = this.model.ScopeScript || '';
            const buildTemplate = config.buildScopeMethodTemplate;
            if (typeof buildTemplate === 'function' && !scopeScriptHasMethod(scopeScript, handlerName)) {
                const block = buildTemplate(handlerName);
                scopeScript = appendMethodToScopeScript(scopeScript, block);
                this.onScopeScriptChanged(scopeScript, { force: true });
            }

            this.openCodeTab();

            const line = findMethodLineNumber(this.model.ScopeScript || scopeScript, handlerName);
            if (line != null)
                this.navigateScopeScriptToLine(line);
        },
        activateDocumentTreeTab() {
            const panel = this._dockviewApi?.getPanel(DOCUMENT_TREE_PANEL_ID);
            if (panel?.api?.setActive)
                panel.api.setActive();
        },
        bindJsonTabTracking(api) {
            this._jsonTabGroupActiveDisposable?.dispose?.();
            this._dockGlobalActiveDisposable?.dispose?.();
            this._jsonTabGroupActiveDisposable = null;
            this._dockGlobalActiveDisposable = null;

            const jsonGroup = getJsonTabGroup(api);
            if (jsonGroup?.api?.onDidActivePanelChange) {
                this._jsonTabGroupActiveDisposable = jsonGroup.api.onDidActivePanelChange((event) => {
                    const id = event?.panel?.id;
                    if (id)
                        this.handleJsonTabChange(id);
                });
            }

            if (api?.onDidActivePanelChange) {
                this._dockGlobalActiveDisposable = api.onDidActivePanelChange((panel) => {
                    const id = panel?.id;
                    const group = getJsonTabGroup(api);
                    const groupPanelIds = new Set(group?.panels?.map((p) => p.id) ?? []);
                    if (id && groupPanelIds.has(id)) {
                        this.handleJsonTabChange(id);
                    } else {
                        this._dockPanelBumpNow();
                    }
                });
            }
        },
        handleJsonTabChange(newId) {
            if (this._suppressJsonTabGroupActivePanelChange)
                return;

            const prevId = this._jsonTabGroupActivePanelId ?? getJsonTabGroupActivePanelId(this._dockviewApi);
            if (newId === prevId)
                return;

            if (prevId === JSON_PANEL_ID && newId !== JSON_PANEL_ID) {
                if (!this.tryLeaveJsonTab()) {
                    this._suppressJsonTabGroupActivePanelChange = true;
                    this.$nextTick(() => {
                        try {
                            this._dockviewApi?.getPanel(JSON_PANEL_ID)?.api?.setActive?.();
                        } finally {
                            this._suppressJsonTabGroupActivePanelChange = false;
                        }
                    });
                    return;
                }
            }

            this._jsonTabGroupActivePanelId = newId;
            if (newId === JSON_PANEL_ID) {
                this.ensureJsonEditorContent(true);
                this._jsonEditorMountKey = (this._jsonEditorMountKey || 0) + 1;
            }
            this._dockPanelBumpNow();
        },
        ensureJsonEditorContent(forceFromModel = false) {
            if (!this.model)
                return;
            if (this.rawjson_ischanged && this.temp_rawjson)
                return;
            if (!forceFromModel && this._jsonEditorMounted && this.temp_rawjson)
                return;
            try {
                this.temp_rawjson = JSON.stringify(this.model, getCircularReplacer(), 4);
                if (!this._jsonEditorMounted)
                    this.rawjson_ischanged = false;
                this._jsonEditorMounted = true;
            } catch (e) {
                console.warn('ControlDesigner_v3: ensureJsonEditorContent failed', e);
                if (!this.temp_rawjson)
                    this.temp_rawjson = '{}';
                this._jsonEditorMounted = true;
            }
        },
        navigateBreadcrumb(index) {
            const bc = this.history[index];
            this.dynamicControl = bc.dynamicControl;
            this.type = bc.type;
            this.designmodel = bc.designmodel;
            this.cData = bc.cData;

            if (index === 0)
                this.history = [];
            else
                this.history = this.history.slice(0, index);

            //for (var i = 0; i < this.actions.length; i++)
            //    utils.executeAction(this.actions[i]);
        },

        getDockLayoutStorageKey() {
            const base = 'control-designer-v3-dockview-layout';
            return this.name ? `${base}-${this.name}` : base;
        },
        getDockLayoutJson() {
            const key = this.getDockLayoutStorageKey();
            let raw = null;
            try {
                if (this.Root?.System?.LocalStorage)
                    raw = this.Root.System.LocalStorage(key);
                else if (typeof window !== 'undefined')
                    raw = window.localStorage.getItem(key);
            } catch {
                raw = null;
            }
            if (!raw)
                return null;
            try {
                return typeof raw === 'string' ? JSON.parse(raw) : raw;
            } catch {
                return null;
            }
        },
        saveDockLayoutJson(data) {
            const key = this.getDockLayoutStorageKey();
            const json = JSON.stringify(data);
            try {
                if (this.Root?.System?.LocalStorage)
                    this.Root.System.LocalStorage(key, json);
                else if (typeof window !== 'undefined')
                    window.localStorage.setItem(key, json);
            } catch (e) {
                console.warn('ControlDesigner_v3: save dock layout failed', e);
            }
        },
        onControlDesignerDockReady(api) {
            this._jsonTabGroupActiveDisposable?.dispose?.();
            this._leftGroupActiveDisposable?.dispose?.();
            this._dockGlobalActiveDisposable?.dispose?.();
            this._dockviewApi = api || null;
            this._boundJsonTabGroupId = null;
            this.bindLeftTabTracking(api);
            this._centerActivePanelId = getCenterActivePanelId(api);
            this._jsonTabGroupActivePanelId = getJsonTabGroupActivePanelId(api);

            if (isJsonTabActive(api)) {
                this.resetJsonTabState();
                if (this.showDesignerDock)
                    this.activateDesignerTab();
                else
                    this.activatePropertiesTab();
                this._jsonTabGroupActivePanelId = this.showDesignerDock
                    ? DESIGNER_PANEL_ID
                    : PROPERTIES_PANEL_ID;
            }

            if (!this.showCode && isCodePanelActive(api))
                activateSiblingOfCodePanel(api);

            this._dockPanelBumpNow();
        },
        resetJsonTabState() {
            this._jsonEditorMounted = false;
            this.rawjson_ischanged = false;
            this.temp_rawjson = '';
        },
        openJsonTab() {
            const panel = this._dockviewApi?.getPanel(JSON_PANEL_ID);
            if (!panel?.api?.setActive)
                return;
            this.ensureJsonEditorContent(true);
            this._jsonEditorMountKey = (this._jsonEditorMountKey || 0) + 1;
            panel.api.setActive();
            this.$nextTick(() => {
                const jsonGroupId = getJsonTabGroupActivePanelId(this._dockviewApi);
                if (jsonGroupId === JSON_PANEL_ID && jsonGroupId !== this._jsonTabGroupActivePanelId) {
                    this.handleJsonTabChange(jsonGroupId);
                } else if (jsonGroupId === JSON_PANEL_ID) {
                    this._dockPanelBumpNow();
                }
            });
        },
        activateDesignerTab() {
            const panel = this._dockviewApi?.getPanel(DESIGNER_PANEL_ID);
            if (panel?.api?.setActive)
                panel.api.setActive();
        },
        activatePropertiesTab() {
            activatePropertiesPanel(this._dockviewApi);
        },
        tryLeaveJsonTab() {
            if (!this.rawjson_ischanged)
                return true;
            return this.applyRawJsonFromEditor();
        },
        ensureRawJsonAppliedBeforeSave() {
            if (!this.rawjson_ischanged)
                return true;
            return this.applyRawJsonFromEditor();
        },
        applyRawJsonFromEditor() {
            try {
                const obj = JSON.parse(this.temp_rawjson);
                this.rawjson_ischanged = false;

                for (let prop in this.model)
                    if (this.model.hasOwnProperty(prop))
                        delete this.model[prop];

                for (let prop in obj)
                    if (obj.hasOwnProperty(prop))
                        this.model[prop] = obj[prop];

                this.getTreePanelRef()?.clearExpansionState();
                this.resetScopeScriptEditorState();
                this.modelHasChanged();
                return true;
            }
            catch (e) {
                alert(e);
                return false;
            }
        },
        cancelJsonTab() {
            this.temp_rawjson = JSON.stringify(this.model, null, 4);
            this.rawjson_ischanged = false;
            this._jsonEditorMountKey = (this._jsonEditorMountKey || 0) + 1;
            if (this.showDesignerDock)
                this.activateDesignerTab();
            else
                this.activatePropertiesTab();
            this._dockPanelBumpNow();
        },
        syncTreeFromJsonCursor(offset) {
            void this.syncTreeFromJsonCursorAsync(offset);
        },
        async syncTreeFromJsonCursorAsync(offset) {
            try {
                const node = resolveJsonCursorToModelNode(this.temp_rawjson, offset, this.model);
                if (!node) {
                    alert('No matching tree node at cursor.');
                    this._jsonPanelRef?.endSyncTreeInteraction?.();
                    return;
                }
                this._dockviewApi?.getPanel(DOCUMENT_TREE_PANEL_ID)?.api?.setActive?.();
                const tree = this.getTreePanelRef();
                tree?.setSelectedNode(node, true, true);
                await this.syncPropertyGridFromTreeNode(node);
                this._jsonPanelRef?.restoreCursorOffset?.(offset);
            }
            catch (e) {
                this._jsonPanelRef?.endSyncTreeInteraction?.();
                alert(e);
            }
        },
        renderControlDesignerDockBreadcrumbs() {
            if (this.history.length === 0)
                return null;

            const crumb_style = {
                cursor: "pointer",
                color: "white",
                backgroundColor: "gray",
                fontSize: "small",
                fontFamily: "Arial",
                margin: "3px",
                padding: "2px",
                borderRadius: "2px",
            };
            const bcitems = [];
            for (let i = 0; i < this.history.length; i++) {
                const bc = this.history[i];
                bcitems.push(
                    <span style={crumb_style} onClick={() => this.navigateBreadcrumb(i)}>
                        <i class="mdi mdi-menu-left" /> {bc.cData.Name || bc.type}
                    </span>
                );
            }
            return (
                <div style={{ minHeight: "30px", display: "flex", flexDirection: "horizontal" }}>
                    {bcitems}
                </div>
            );
        },
        blockPropertyGridPointer(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        renderControlDesignerDockPanel(panelId) {
            void this._jsonTabGroupActivePanelId;
            void this._centerActivePanelId;
            void this._dockRev;
            void this.jsonTabActive;
            void this.codeTabActive;
            void this._codePanelActive;
            void this.propertiesTabActive;
            void this._propertiesPanelActive;
            void this._leftActivePanelId;
            void this.legacyScopeMigrationPending;
            const showDesigner = this.showDesignerDock;
            const form = this._propertyGridForm || ['*'];
            const pgReadonly = isJsonTabActive(this._dockviewApi);

            switch (panelId) {
                case 'documentTree':
                    if (!this.showTree)
                        return null;
                    return (
                        <DocumentTreePanel
                            ref={(el) => { this._treePanelRef = el; }}
                            model={this.model}
                            title={this.treeTitleDisplay}
                            history={this.treeHistory}
                            root={this.root}
                            onUpdate:selectedNode={this.onTreeNodeSelected}
                            onNavigateBack={this.navigateTreeBack}
                        />
                    );
                case 'code':
                    if (!this.showCode)
                        return null;
                    return (
                        <ControlDesignerCodePanel
                            ref={(el) => { this._codePanelRef = el; }}
                            active={this.codeTabActive}
                            content={this.model?.ScopeScript ?? ''}
                            scopeIncludes={Array.isArray(this.model?.ScopeIncludes) ? this.model.ScopeIncludes : EMPTY_ARRAY}
                            scopePublic={Array.isArray(this.model?.ScopePublic) ? this.model.ScopePublic : EMPTY_ARRAY}
                            variables={Array.isArray(this.model?.Variables) ? this.model.Variables : EMPTY_ARRAY}
                            functions={Array.isArray(this.model?.Functions) ? this.model.Functions : EMPTY_ARRAY}
                            legacyMigrationPending={this.legacyScopeMigrationPending}
                            designRoot={this.designmodel}
                            actionSet={Array.isArray(this.model?.ActionSet) ? this.model.ActionSet : EMPTY_ARRAY}
                            resolveActionSet={() => this.model?.ActionSet}
                            commands={Array.isArray(this.model?.Commands) ? this.model.Commands : EMPTY_ARRAY}
                            resolveCommands={() => this.model?.Commands}
                            controlDataSchema={this.model?.ControlDataSchema ?? null}
                            mountKey={this._scopeScriptMountKey || 0}
                            onChangeContent={(text) => this.onScopeScriptChanged(text)}
                            onChangeScopeIncludes={(includes) => this.onScopeIncludesChanged(includes)}
                            onChangeScopePublic={(names) => this.onScopePublicChanged(names)}
                            onMigrateLegacyScope={() => this.onMigrateLegacyScope()}
                            onAddOnCreated={() => this.addOnCreated()}
                            onAddOnMounted={() => this.addOnMounted()}
                        />
                    );
                case 'designer':
                    if (!showDesigner)
                        return null;
                    {
                        let DynamicControl = utils.dynamicComponents[this.dynamicControl];
                        if (!DynamicControl)
                            DynamicControl = utils.dynamicComponents['default-unknown-dsgn'];
                        return (
                            <div class="designer-base" style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, overflow: "auto" }}>
                                {this.renderControlDesignerDockBreadcrumbs()}
                                <DynamicControl
                                    key={this.designmodel ? this.designmodel.$objectId : '_id_'}
                                    root={this}
                                    type={this.type}
                                    parentType="VerticalStack"
                                    designmodel={this.designmodel}
                                    controlData={this.cData}
                                    controlName="controlDesigner"
                                    scopeitems={this.scopeitems}
                                    controlscope={this.controlscope}>
                                </DynamicControl>
                            </div>
                        );
                    }
                case 'json':
                    this.ensureJsonEditorContent();
                    return (
                        <ControlDesignerJsonPanel
                            ref={(el) => { this._jsonPanelRef = el; }}
                            active={isJsonTabActive(this._dockviewApi)}
                            content={this.temp_rawjson || ''}
                            mountKey={this._jsonEditorMountKey || 0}
                            hasUncommittedEdits={this.rawjson_ischanged}
                            onChangeContent={(text) => this.rawjsonchanged(text)}
                            onCancel={() => this.cancelJsonTab()}
                            onSync-tree={(offset) => this.syncTreeFromJsonCursor(offset)}
                        />
                    );
                case 'properties':
                    return (
                        <ControlDesignerPropertiesPanel active={this.propertiesTabActive}>
                            <PropertyGrid
                                name={this.model.Name || this.model.MenuName}
                                root={this}
                                parentType="VerticalStack"
                                schema={this.sel_schema}
                                form={form}
                                cmodel={this.sel_model}
                                child={0}
                                readonly={pgReadonly}
                                navigateToModel={this.navigateToModel}
                            />
                            {pgReadonly ? (
                                <div
                                    class="designer-container-hovering control-designer-property-grid-blocker"
                                    title="Property editing is disabled while the JSON tab is open"
                                    onPointerDown={this.blockPropertyGridPointer}
                                    onMouseDown={this.blockPropertyGridPointer}
                                    onClick={this.blockPropertyGridPointer}
                                    onDblClick={this.blockPropertyGridPointer}
                                />
                            ) : null}
                        </ControlDesignerPropertiesPanel>
                    );
                default:
                    return null;
            }
        },

        jsEditorHandleMouseDown(e) {
            document.addEventListener('mousemove', this.jsEditorHandleMouseMove);
            document.addEventListener('mouseup', this.jsEditorHandleMouseUp);
            this._jsEditorInitialX = e.clientX;
            this._jsEditorInitialLeft = this.js_editor_left;
            e.preventDefault();
            e.stopPropagation();
        },
        jsEditorHandleMouseMove(e) {
            const minBarWidth = 120;
            const maxLeft = Math.max(0, (typeof window !== 'undefined' ? window.innerWidth : 0) - minBarWidth);
            const dx = e.clientX - this._jsEditorInitialX;
            let next = this._jsEditorInitialLeft + dx;
            this.js_editor_left = Math.min(maxLeft, Math.max(0, next));
            e.preventDefault();
            e.stopPropagation();
        },
        jsEditorHandleMouseUp(e) {
            document.removeEventListener('mousemove', this.jsEditorHandleMouseMove);
            document.removeEventListener('mouseup', this.jsEditorHandleMouseUp);
            e.preventDefault();
            e.stopPropagation();
        },

        rawjsonchanged(text) {
            if (text === this.temp_rawjson)
                return;
            this.temp_rawjson = text;
            this.rawjson_ischanged = true;
            this._dockPanelBumpNow();
        },
        test() {
            const origin = window.location.origin;
            const path = window.location.pathname;
            const name = (this.model.Public ? 'public/' : '') + this.model.Name;
            //const access_token = encodeURIComponent(this.Root.Root.access_token);

            const url = origin + path + '#' + name;

            window.open(url, '_blank');
        },
        async verifyHsm() {
            const hsmname = (this.model.Public ? 'public/' : '') + this.model.Name;
            const url = 'Apps/HSM/Errors/' + hsmname + '?forceReload=true';
            try {
                const res = await utils.api.get(url);
                if (res)
                    this.hsm_errors = res;
                else
                    this.hsm_errors = [];
            }
            catch (e) {
                utils.log(JSON.stringify(e));

                this.hsm_errors = [{
                    Type: 'Critical',
                    Name: this.model.Name,
                    Message: e.reasonPhrase,
                    ObjectId: ''
                }];
            }
        },
        revert(e) {
            this.model = null;
            this.Refresh();
        },
        async loadDocRevisions() {
            let db = 'ui';

            if (this.model && this.model._id)
                this.doc_revisions = await utils.api.get('Apps/DocumentRevisions/' + db + '?id=' + encodeURIComponent(this.model._id));
            else
                this.doc_revisions = [];
        },
        async loadAuditHistory() {
            if (this.model && this.model._id)
                // Apps/AuditHistory/ChangesById?DocumentID=83b91d21-c43b-4c89-8733-549ff6a6ff28&sortcol=time&startKey=[]&descending=true&maxMonths=12
                //this.doc_changes = await utils.api.get('Apps/AuditHistory/ChangesById?DocumentId=' + encodeURIComponent(this.model._id) + '&sortcol=time&startKey=[]&descending=true&maxMonths=' + this.max_months_history);
            {
                const action = [
                    {
                        "$typeSchema": "/schema/public/Platform.Schema.UIActions.v1/UIAction_Reference",
                        "PrimitiveAction": true,
                        "ActionType": "ReferenceUserAction",
                        "RunAsync": false,
                        "ActionData": {
                            "UserAction": {
                                "ActionData": {
                                    "DocumentID": this.model._id,
                                    "TabTitle": this.model.Name
                                },
                                "CacheAction": true,
                                "ActionURL": "public/AuditHistory/OpenActivityByDocumentID"
                            }
                        }
                    }
                ];

                utils.executeAndCompileAllActions(action, {}, this);
            }
            else
                this.doc_changes = [];
        },
        async loadRevision(rev) {
            let db = 'ui';
            let url = 'Apps/Document/' + db + '/' + encodeURIComponent(this.model._id) + '?rev=' + rev;
            this.ExternalNavigate(url);
        },
        async loadAuditHistoryVersion(moddatetime) {
            let doc = this.doc_changes.find(a => a.time == moddatetime);
            let url;
            if (doc == null)
                url = 'Apps/Raw/UI/' + this.model.$doctype + '/' + encodeURIComponent(this.model._id);
            else
                url = 'Apps/AuditHistory/ChangedContent/' + doc.document_refid;

            this.ExternalNavigate(url);
        },
        async refreshTracking() {
            if (this.model && this.model._id) {
                const obj = {
                    user: this.fullName || 'Unknown',
                    since: this.editing_since ? this.editing_since.toString() : new Date(),
                    revision: this.model ? this.model._rev : '',
                };
                try {
                    const edits = await utils.api.request('POST', 'Apps/UIExt/Tracker?key=' + encodeURIComponent(this.model._id), obj);
                    if (!trackerEditsEqual(this.edits, edits))
                        this.edits = edits;
                }
                catch (e) {
                    utils.error('Error posting to edit tracker', e);
                }
            }
            const tmp = this;
            this.timeoutReference = window.setTimeout(async () => {
                tmp.refreshTracking();
            }, 10 * 1000);
        },
        clearTracking() {
            if (!this.model || !this.model._id) return;
            utils.api.request('DELETE', 'Apps/UIExt/Tracker?key=' + encodeURIComponent(this.model._id));
        },

        js_code_changed(text) {
            if (this.js_code)
                this.js_code.Javascript = text;
        },
        findNode(parent, id) {
            if (parent && typeof parent === 'object' && '$objectId' in parent)
                if (parent['$objectId'] == id)
                    return parent;
                else
                    utils.log(' '.repeat(this.indent) + '$objectId = ' + parent['$objectId']);

            if (!parent)
                return null;

            this.indent = this.indent + 1;

            const keys = Object.keys(parent);
            for (let j = 0; j < keys.length; j++) {
                const key = keys[j];
                const child = parent[key];
                utils.log(' '.repeat(this.indent) + 'key:' + key);

                if (typeof child === 'object') {
                    if (Array.isArray(child)) {
                        utils.log(' '.repeat(this.indent) + 'is array');
                        for (let i = 0; i < child.length; i++) {
                            const node = this.findNode(child[i], id);
                            if (node) return node;
                        }
                    }
                    else {
                        utils.log(' '.repeat(this.indent) + 'is object, scanning child');
                        const node = this.findNode(child, id);
                        if (node) return node;
                    }
                }
                else
                    utils.log(' '.repeat(this.indent) + key + ' : ' + child);
            }
            this.indent = this.indent - 1;
            return null;
        },
        hsmNavigateTo: function (id) {
            this.indent = 0;
            let node = this.findNode(this.model, id);
            if (node) {
                this.navigateToModel(node);
            }
            else
                alert(`Cannot locate node with $objectId: ${id}`);
        },
        getHsmErrors: function (h) {
            const style = {
                overflow: "auto",
                display: "flex",
                "flex-direction": "column",
                "min-height": "100px",
                "min-width": "600px",
                "padding": "5px 10px 0 0",
                "margin": "0",
                "resize": "both"
            };
            const errors = [];
            for (let i = 0; i < this.hsm_errors.length; i++) {
                const e = this.hsm_errors[i];
                let jump;
                if (e.ObjectId)
                    jump = <span style={{ cursor: "pointer" }} onClick={() => this.hsmNavigateTo(e.ObjectId)}>Goto</span>;
                else
                    jump = <span>Error</span>;

                errors.push(
                    <tr>
                        <td style={{ padding: "0 5px 0 5px", border: "1px solid silver" }}>{jump}</td>
                        <td style={{ padding: "0 5px 0 5px", border: "1px solid silver" }}>{e.Type}</td>
                        <td style={{ padding: "0 5px 0 5px", border: "1px solid silver" }}>{e.Message}</td>
                    </tr>
                );
            }
            return (
                <div style={style}>
                    <div style={{ display: "flex", flexDirection: "row", flexGrow: "1" }}>
                        <div style={{
                            display: "flex", flexDirection: "columns", flexGrow: "1",
                            borderStyle: 'solid', borderWidth: '1px', "box-sizing": "border-box", "overflow": "auto",
                            backgroundColor: "white",
                            color: "black",
                            overflow: "auto"
                        }}>
                            <table width="100%" style={{ borderCollapse: "collapse", borderColor: "silver" }}>
                                <tr>
                                    <th></th>
                                    <th>Type</th>
                                    <th>Error</th>
                                </tr>
                                {errors}
                            </table>
                        </div>
                    </div>
                </div>);
        },
        refreshJSCode: function () {
            this.js_enabled = false;
            this.js_open = false;
            this.js_code = null;
        },
        toggleJSOpen: function () {
            this.js_open = !this.js_open;
            this.js_enabled = true;
        },
        _attachJsEditorResizeObserver: function () {
            if (!this.js_enabled || !this.js_code)
                return;
            // When popup is closed, disconnect so we don't observe a hidden element (avoids bad callbacks)
            if (!this.js_open) {
                if (this._jsEditorResizeObserver && this._jsEditorResizeEl) {
                    this._jsEditorResizeObserver.unobserve(this._jsEditorResizeEl);
                    this._jsEditorResizeObserver = null;
                    this._jsEditorResizeEl = null;
                }
                return;
            }
            const el = this.$el?.querySelector?.('.js-editor-popup-container');
            if (!el || el === this._jsEditorResizeEl)
                return;
            if (this._jsEditorResizeObserver && this._jsEditorResizeEl) {
                this._jsEditorResizeObserver.unobserve(this._jsEditorResizeEl);
                this._jsEditorResizeObserver = null;
                this._jsEditorResizeEl = null;
            }
            this._jsEditorResizeEl = el;
            this._jsEditorResizeObserver = new ResizeObserver((entries) => {
                const entry = entries[0];
                if (entry?.contentRect) {
                    const h = Math.round(entry.contentRect.height);
                    const w = Math.round(entry.contentRect.width);
                    // Only update when size *increases* (user resized larger). Never shrink from observer
                    // so layout/visibility changes can't overwrite the user's size.
                    if (h >= 300 && h > this.js_editor_height) this.js_editor_height = h;
                    if (w >= 600 && w > this.js_editor_width) this.js_editor_width = w;
                }
            });
            this._jsEditorResizeObserver.observe(el);
        },
        _attachControlSettingsResizeObserver: function () {
            if (!this.UserControlSettingsOpen) {
                if (this._controlSettingsResizeObserver && this._controlSettingsResizeEl) {
                    this._controlSettingsResizeObserver.unobserve(this._controlSettingsResizeEl);
                    this._controlSettingsResizeObserver = null;
                    this._controlSettingsResizeEl = null;
                }
                return;
            }
            const el = this.$el?.querySelector?.('.control-settings-resize-container') ?? document.querySelector('.control-settings-resize-container');
            if (!el || el === this._controlSettingsResizeEl)
                return;
            if (this._controlSettingsResizeObserver && this._controlSettingsResizeEl) {
                this._controlSettingsResizeObserver.unobserve(this._controlSettingsResizeEl);
                this._controlSettingsResizeObserver = null;
                this._controlSettingsResizeEl = null;
            }
            this._controlSettingsResizeEl = el;
            this._controlSettingsResizeObserver = new ResizeObserver((entries) => {
                const entry = entries[0];
                if (entry?.contentRect) {
                    const w = Math.round(entry.contentRect.width);
                    const h = Math.round(entry.contentRect.height);
                    if (w >= 400 && w > this.userControlSettingsWidth) this.userControlSettingsWidth = w;
                    if (h >= 320 && h > this.userControlSettingsHeight) this.userControlSettingsHeight = h;
                }
            });
            this._controlSettingsResizeObserver.observe(el);
        },
        getJavascriptEditor: function () {
            if (!this.js_enabled || !this.js_code)
                return null;

            const containerStyle = {
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                height: this.js_editor_height + "px",
                minHeight: "300px",
                width: this.js_editor_width + "px",
                minWidth: "600px",
                padding: "0 10px 10px 10px",
                margin: "0",
                resize: "both",
                direction: "rtl",
                transform: "rotate(180deg)"
            };

            return (
                <div key="js-editor-popup" class="js-editor-popup-container" v-show={this.js_open} style={containerStyle}>
                    <div style={{ display: "flex", flexDirection: "row", flexGrow: 1, minHeight: 0, transform: "rotate(180deg)" }}>
                        <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, minHeight: 0, borderStyle: "solid", borderWidth: "1px", boxSizing: "border-box", overflow: "auto" }}>
                            <AceEditor
                                key="editor_js_code"
                                editorId="editor_js_code"
                                lang="javascript"
                                content={this.js_code.Javascript}
                                onChangeContent={(text) => this.js_code_changed(text)}
                            />
                        </div>
                    </div>
                </div>
            );
        },

        addVariable: function () {
            this.model.Variables.push({
                Name: 'Unnamed',
                Public: false,
                InitialValue: '',
            });
            this.variablesSelection = String(this.model.Variables.length - 1);
        },
        removeVariable: function (index) {
            if (index >= 0 && index < this.model.Variables.length) {
                this.model.Variables.splice(index, 1);
                this.variablesSelection = this.model.Variables.length === 0 ? '0' : String(Math.min(index, this.model.Variables.length - 1));
            }
        },
        addFunction: function () {
            this.model.Functions.push({
                Name: 'Unnamed',
                Public: false,
                Body: 'function (a)\n{\n\treturn a;\n}\n',
            });
            this.functionsSelection = String(this.model.Functions.length - 1);
        },
        removeFunction: function (index) {
            if (index >= 0 && index < this.model.Functions.length) {
                this.model.Functions.splice(index, 1);
                this.functionsSelection = this.model.Functions.length === 0 ? '0' : String(Math.min(index, this.model.Functions.length - 1));
            }
        },
        getUserControlSettings: function () {
            if (this.model.$typeSchema != '/schema/public/Platform.Schema.Documents.v1/Document_UserControl')
                return null;

            let vtabs, vtabs_content;
            if (this.UserControlSettingsTabs == 'one') {
                vtabs = this.model.Variables?.map((a, i) =>
                    <QTab key={i} name={String(i)} label={a.Name} />
                );
                vtabs_content = this.model.Variables?.map((a, i) =>
                    <QTabPanel key={i} name={String(i)} style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
                        <div class="property-grid" style={{ display: 'flex', flexDirection: 'row' }}>
                            Name: <QInput dense outlined hide-bottom-space class="q-ml-sm q-mb-xs" modelValue={a.Name} onUpdate:modelValue={(value) => { a.Name = value; }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1, minHeight: '200px', minWidth: '200px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, border: '1px solid gray', boxSizing: 'border-box', overflow: 'auto' }}>
                                <AceEditor editorId={`editor_js_variable_${i}`} lang="json" content={JSON.stringify(a.InitialValue, null, 3)} onChangeContent={(text) => a.InitialValue = JSON.parse(text)} />
                            </div>
                        </div>
                    </QTabPanel>
                );
            }

            let ftabs, ftabs_content;
            if (this.UserControlSettingsTabs == 'two') {
                ftabs = this.model.Functions?.map((a, i) =>
                    <QTab key={i} name={String(i)} label={a.Name} style="justify-content: left !important;" />
                );
                ftabs_content = this.model.Functions?.map((a, i) =>
                    <QTabPanel key={i} name={String(i)} style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
                        <div class="property-grid" style={{ display: 'flex', flexDirection: 'row' }}>
                            Name: <QInput dense outlined hide-bottom-space class="q-ml-sm q-mb-xs" modelValue={a.Name} onUpdate:modelValue={(value) => { a.Name = value; }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1, minHeight: '200px', minWidth: '200px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, border: '1px solid gray', boxSizing: 'border-box', overflow: 'auto' }}>
                                <AceEditor editorId={`editor_js_function_${i}`} lang="javascript" content={a.Body} onChangeContent={(text) => a.Body = text} />
                            </div>
                        </div>
                    </QTabPanel>
                );
            }

            const card = (
                <QCard style={{ flexGrow: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>
                    <QCardSection>
                        <div class="text-h6">Control Settings</div>
                        <div class="text-caption text-grey">Defines variables and functions that can be referenced throughout the user control with the Control object.</div>
                    </QCardSection>
                    <QTabs align="left" modelValue={this.UserControlSettingsTabs} onUpdate:modelValue={(v) => this.UserControlSettingsTabs = v}>
                        <QTab name="one" label="Variables" />
                        <QTab name="two" label="Functions" />
                    </QTabs>
                    <QCardSection style={{ flexGrow: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>
                        <QTabPanels modelValue={this.UserControlSettingsTabs} onUpdate:modelValue={(v) => this.UserControlSettingsTabs = v} style={{ flexGrow: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>
                            <QTabPanel name="one" style={{ flexGrow: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>
                                <div class="q-mb-sm">
                                    <QBtn size="sm" color="primary" onClick={() => this.addVariable()}>Add</QBtn>
                                    <QBtn size="sm" color="negative" class="q-ml-sm" onClick={() => this.removeVariable(parseInt(this.variablesSelection, 10))}>Remove</QBtn>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', xminWidth: '800px', xmaxHeight: '400px', flexGrow: "1", minHeight: 0 }}>
                                    <div style={{ overflowY: 'auto', minHeight: 0, border: '1px solid gray', borderRadius: '8px', minWidth: '150px' }}>
                                        <QTabs modelValue={this.variablesSelection} onUpdate:modelValue={(v) => this.variablesSelection = v} vertical inline-label class="q-tabs--vertical vertical-tabs-left">
                                            {vtabs}
                                        </QTabs>
                                    </div>
                                    <QTabPanels modelValue={this.variablesSelection} onUpdate:modelValue={(v) => this.variablesSelection = v} style={{ border: '1px solid gray', borderRadius: '8px', marginLeft: '5px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                                        {vtabs_content}
                                    </QTabPanels>
                                </div>
                            </QTabPanel>
                            <QTabPanel name="two" style={{ flexGrow: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>
                                <div class="q-mb-sm">
                                    <QBtn size="sm" color="primary" onClick={() => this.addFunction()}>Add</QBtn>
                                    <QBtn size="sm" color="negative" class="q-ml-sm" onClick={() => this.removeFunction(parseInt(this.functionsSelection, 10))}>Remove</QBtn>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', xminWidth: '800px', xmaxHeight: '400px', flexGrow: "1", minHeight: 0 }}>
                                    <div style={{ overflowY: 'auto', minHeight: 0, border: '1px solid gray', borderRadius: '8px', minWidth: '150px' }}>
                                        <QTabs modelValue={this.functionsSelection} onUpdate:modelValue={(v) => this.functionsSelection = v} vertical inline-label class="q-tabs--vertical vertical-tabs-left">
                                            {ftabs}
                                        </QTabs>
                                    </div>
                                    <QTabPanels modelValue={this.functionsSelection} onUpdate:modelValue={(v) => this.functionsSelection = v} style={{ border: '1px solid gray', borderRadius: '8px', marginLeft: '5px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                                        {ftabs_content}
                                    </QTabPanels>
                                </div>
                            </QTabPanel>
                        </QTabPanels>
                    </QCardSection>
                    <QCardActions>
                        <QBtn size="sm" color="primary" onClick={() => this.UserControlSettingsOpen = false}>Close</QBtn>
                    </QCardActions>
                </QCard>
            );

            const controlSettingsWrapperStyle = {
                width: this.userControlSettingsWidth + 'px',
                height: this.userControlSettingsHeight + 'px',
                minWidth: '400px',
                minHeight: '320px',
                resize: 'both',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
            };

            return (
                <QBtn {...btnProps} icon="mdi-cogs">
                    <QMenu modelValue={this.UserControlSettingsOpen} onUpdate:modelValue={(v) => { this.UserControlSettingsOpen = v; if (v) this.$nextTick(() => this._attachControlSettingsResizeObserver()); }} anchor="bottom left" self="top left"
                        style="display: flex; flex-direction: column; max-height: unset;"
                    >
                        <div class="control-settings-resize-container" style={controlSettingsWrapperStyle}>
                            {card}
                        </div>
                    </QMenu>
                </QBtn>
            );
        },

        $on(eventname, method) {
            this._events.on(eventname, method);
        },
        $off(eventname, method) {
            this._events.off(eventname, method);
        },
        $emitself(eventname, args) {
            this._events.emit(eventname, args);
        },
    },
    props: {
        name: '',
        root: null,
        parentType: '',
        controlData: {},
        scopeitems: null,
        controlscope: null,
    },
    render() {
        if (!this.model)
            return <TranslationContainer context={this} value="Loading..."></TranslationContainer>;

        try {

            const styleLink = "https://docs.google.com/presentation/d/1O-ReVkqQJXzXr5DUkY8YSSqIbuLqm4f511zjdYSmnzg/edit#slide=id.p";
            let styleID = <a href={styleLink} target="_blank">Style Guide</a>;

            let publicChkbx;
            if (this.jsonTabActive)
                publicChkbx = <span style="margin-left: 10px;">Public: <input type="checkbox" style={{ margin: "5px" }} checked={this.model.Public} disabled /></span>;
            else
                publicChkbx = <span style="margin-left: 10px;">Public: <input type="checkbox" style={{ margin: "5px" }} checked={this.model.Public} onChange={(e) => this.sync("Public", e.target.checked)} /></span>;

            let viewJsonChkbx;
            //if (this.jsonTabActive)
            //    viewJsonChkbx = utils.tt('Designer', <QBtn {...btnProps} color="secondary" class="q-py-none" icon="mdi-cog" onClick={(e) => this.activateDesignerTab()} />);
            //else
            //    viewJsonChkbx = utils.tt('Edit JSON', <QBtn {...btnProps} class="q-py-none" icon="mdi-cog" onClick={(e) => this.openJsonTab()} />);

            let viewDesgnChkbx;
            if (this.mode == 'Schema')
                viewDesgnChkbx = null;
            else if (this.jsonTabActive)
                viewDesgnChkbx = <QBtn {...btnProps} disable icon="mdi-window-restore" color="grey" />;
            else if (this.viewdsgn)
                viewDesgnChkbx = utils.tt('Hide Designer', <QBtn {...btnProps} icon="mdi-window-restore" color="blue" onClick={(e) => this.viewdsgn = false} />);
            else
                viewDesgnChkbx = utils.tt('Show Designer', <QBtn {...btnProps} icon="mdi-window-restore" color="navy" onClick={(e) => this.viewdsgn = true} />);

            let navup;
            if (this.ismodelselected && !this.jsonTabActive)
                navup = utils.tt('Navigate to Parent', <QBtn {...btnProps} icon="mdi-arrow-up" onClick={() => this.navigateUp()}> Up </QBtn>);
            else
                navup = <QBtn {...btnProps} disable icon="mdi-arrow-up"> Up </QBtn>;

            const readOnly = this.VarByName('Customer') && (this.VarByName('Customer').CustomerID !== this.model.CustomerID);
            let readOnlyText;
            if (readOnly)
                readOnlyText = <span title="You are not the owner of this document" style={{ color: "red" }}>Read-Only</span>;

            let header, header2;
            let nameLabel;
            let nameInput;
            let autoreplace;
            let save;
            let savenew;
            let test;
            let compile;
            let audit_history;
            switch (this.mode) {
                case 'UserControl':
                case 'Action':
                case 'UserDefinedArea':
                    {
                        nameLabel = "Name:";
                        if (this.jsonTabActive)
                            nameInput = <div style={{ flex: 1, minWidth: 0 }}><QInput outlined dense hide-bottom-space class="bg-white" style={{ width: '100%' }} modelValue={this.model.Name} readonly /></div>;
                        else
                            nameInput = <div style={{ flex: 1, minWidth: 0 }}><QInput outlined dense hide-bottom-space class="bg-white" style={{ width: '100%' }} modelValue={this.model.Name} onUpdate:modelValue={(value) => this.sync("Name", value)} /></div>;

                        if (this.save_in_progress)
                            save = <QBtn {...btnProps} title="Saving..." disable>Save</QBtn>;
                        else if (readOnly)
                            save = <QBtn {...btnProps} title="Document is read-only, you do not own it" disable>Save</QBtn>;
                        else
                            save = <QBtn {...btnProps} onClick={() => this.saveUserControl(this.mode, this.forceOverwrite)}>{this.hasNameChanged ? 'Rename' : 'Save'}</QBtn>;

                        if (this.can_autoreplace)
                            autoreplace = <span>Force Overwrite: <input type="checkbox" checked={this.forceOverwrite} onChange={(e) => this.forceOverwrite = e.target.checked} /></span>;

                        if (this.save_in_progress)
                            savenew = <QBtn {...btnProps} disable>Save As New</QBtn>;
                        else if (this.hasNameChanged || readOnly)
                            savenew = <QBtn {...btnProps} onClick={() => this.saveUserControlAsNew(this.mode)}>Save As New</QBtn>;
                        else
                            savenew = <QBtn {...btnProps} disable>Save As New</QBtn>;

                        test = <QBtn {...btnProps} onClick={() => this.test()}>Test</QBtn>;

                        if (this.model.Data && this.model.Data.ControlType == 'Hsm')
                            compile = <QBtn {...btnProps} onClick={() => this.verifyHsm()}>Verify HSM</QBtn>;

                        break;
                    }

                case 'MenuItem':
                    {
                        nameLabel = "Menu Title:";
                        if (this.jsonTabActive)
                            nameInput = <div style={{ flex: 1, minWidth: 0 }}><QInput outlined dense hide-bottom-space class="bg-white" style={{ width: '100%' }} modelValue={this.model.MenuItemData.Title} readonly /></div>;
                        else
                            nameInput = <div style={{ flex: 1, minWidth: 0 }}><QInput outlined dense hide-bottom-space class="bg-white" style={{ width: '100%' }} modelValue={this.model.MenuItemData.Title} onUpdate:modelValue={(value) => this.sync("MenuItemData.Title", value)} /></div>;

                        if (this.save_in_progress)
                            save = <QBtn {...btnProps} title="Saving..." disable>Save</QBtn>;
                        else if (readOnly)
                            save = <QBtn {...btnProps} title="Document is read-only, you do not own it" disable>Save</QBtn>;
                        else
                            save = <QBtn {...btnProps} onClick={() => this.saveMenuItem(this.forceOverwrite)}>{this.hasNameChanged ? 'Rename' : 'Save'}</QBtn>;

                        if (this.can_autoreplace)
                            autoreplace = <span>Force Overwrite: <input type="checkbox" checked={this.forceOverwrite} onChange={(e) => this.forceOverwrite = e.target.checked} /></span>;

                        if (this.save_in_progress)
                            savenew = <QBtn {...btnProps} disable>Save As New</QBtn>;
                        else if (this.hasNameChanged || readOnly)
                            savenew = <QBtn {...btnProps} onClick={() => this.saveMenuItemAsNew()}>Save As New</QBtn>;
                        else
                            savenew = <QBtn {...btnProps} disable>Save As New</QBtn>;

                        break;
                    }

                case 'Schema':
                    {
                        viewDesgnChkbx = null;
                        nameLabel = "Schema Name:";
                        if (this.jsonTabActive)
                            nameInput = <div style={{ flex: 1, minWidth: 0 }}><QInput outlined dense hide-bottom-space class="bg-white" style={{ width: '100%' }} modelValue={this.model.Namespace + '.' + this.model.Name} readonly /></div>;
                        else
                            nameInput = <div style={{ flex: 1, minWidth: 0 }}><QInput outlined dense hide-bottom-space class="bg-white" style={{ width: '100%' }} modelValue={this.model.Namespace + '.' + this.model.Name} onUpdate:modelValue={(value) => this.syncSchemaName(value)} /></div>;

                        if (this.save_in_progress)
                            save = <QBtn {...btnProps} title="Saving..." disable>Save</QBtn>;
                        else if (readOnly)
                            save = <QBtn {...btnProps} title="Document is read-only, you do not own it" disable>Save</QBtn>;
                        else
                            save = <QBtn {...btnProps} onClick={() => this.saveSchema()}>{this.hasNameChanged ? 'Rename' : 'Save'}</QBtn>;

                        if (this.save_in_progress)
                            savenew = <QBtn {...btnProps} disable>Save As New</QBtn>;
                        else if (this.hasNameChanged || readOnly)
                            savenew = <QBtn {...btnProps} onClick={() => this.saveSchemaAsNew()}>Save As New</QBtn>;
                        else
                            savenew = <QBtn {...btnProps} disable>Save As New</QBtn>;

                        break;
                    }
            }

            if (this.doc_changes && this.doc_changes.length) {
                let items = this.doc_changes.map(a => <option value={a.time}>{this.f_date(a.time, 'medium')}</option>);
                // If the current document is in the changes list, don't bother adding it. Otherwise, put the current at the top of the list
                if (!this.doc_changes.find(a => a.time == this.model.$Modify_DateTime))
                    items = [
                        <option value={this.model.$Modify_DateTime}>{this.f_date(this.model.$Modify_DateTime, 'medium')}</option>,
                        ...items
                    ];
                audit_history = (
                    <select value={this.model.$Modify_DateTime} onChange={(e) => this.loadAuditHistoryVersion(e.target.value)}>
                        {[
                            <option value="_nothing_">Latest</option>,
                            ...items
                        ]}
                    </select>
                );
            }

            header = (this.VarByName('Customer') && (this.VarByName('Customer').CustomerID == "50")) ? [styleID, publicChkbx, nameLabel, nameInput] : [publicChkbx, nameLabel, nameInput];

            header2 = [readOnlyText, save, savenew, autoreplace, compile]; // Removed test as 2nd from last (8/17/23) not useful anyway

            // Keep overflow:hidden after getSize — overflow:auto on this fill root
            // toggles both scrollbars (~11px) and jitters the editor at some sizes.
            const style = {
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
                overflow: "hidden",
            };

            let revision_list;
            if (this.doc_revisions.length > 0)
                revision_list = (
                    <select value={this.model._rev} onChange={(e) => this.loadRevision(e.target.value)}>
                        {this.doc_revisions.filter(a => a.status == 'available').map(a => <option value={a.rev}>{a.rev.split('-')[0]}</option>)}
                    </select>
                );

            const editing = [];
            let outofdate;
            if (this.edits) {
                const colors = ['orange', 'yellow', 'cyan', 'magenta', 'lime'];
                for (let i = 0; i < this.edits.length; i++) {
                    if (this.edits[i].user == this.fullName)
                        continue;

                    let thisrev, thatrev;
                    if (this.model && this.model._rev && this.edits[i].revision) {
                        thisrev = parseInt(this.model._rev.split('-')[0]);
                        thatrev = parseInt(this.edits[i].revision.split('-')[0]);
                        if (thatrev > thisrev)
                            outofdate = (
                                <span>
                                    <i style={{ color: 'red' }} class="mdi mdi-alert warning-blinking" title="You are not editing the latest version!" />
                                </span>
                            );
                    }

                    const color = colors[i % colors.length];
                    const dt = new Date(this.edits[i].since);
                    editing.push(
                        <span>
                            <i style={{ color: color }} class="mdi mdi-account" title={'Currently being edited by ' + this.edits[i].user + ' since ' + dt.toLocaleTimeString() + ' revision ' + thatrev} />
                        </span>
                    );
                }
            }

            let revision;
            if (this.model._rev)
                revision = <span title={this.model._rev}>{this.model._rev.split('-')[0]}</span>;
            else
                revision = <span>New</span>;

            if (!this.js_code) {
                if (this.model.Data && this.model.Data.ControlData && this.model.Data.ControlData.Javascript)
                    this.js_code = this.model.Data.ControlData;
            }

            let jseditor;
            if (this.js_code) {
                let js_refresh;
                if (this.js_open)
                    js_refresh = <i style={{ color: "white", cursor: "pointer" }} title="Refresh" class="mdi mdi-cached" onClick={(e) => this.refreshJSCode()} />;

                jseditor = (
                    <div style={{ position: "fixed", left: this.js_editor_left + "px", bottom: "0", zIndex: "999", backgroundColor: "maroon", color: "white", padding: "2px", borderRadius: "8px 8px 0 0", display: "flex", flexDirection: "column" }}>
                        {this.getJavascriptEditor()}
                        <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <span title="Drag to reposition" style={{ cursor: "grab", padding: "2px 6px", marginRight: "2px" }} onMousedown={(e) => { e.preventDefault(); e.stopPropagation(); this.jsEditorHandleMouseDown(e); }}>
                                <i class="mdi mdi-format-align-justify" />
                            </span>
                            <span style={{ cursor: "pointer", margin: "0 10px" }} onClick={(e) => this.toggleJSOpen()}>Javascript</span>
                            {js_refresh}
                        </div>
                    </div>);
            }

            let hsmerrors;
            if (this.hsm_errors.length > 0)
                hsmerrors = (
                    <div style={{ position: "fixed", bottom: "0", zIndex: "999", backgroundColor: "red", color: "white", marginLeft: "100px", padding: "2px 5px 2px 10px", borderRadius: "8px 8px 0 0" }}>
                        {this.hsm_errors_open ? this.getHsmErrors(h) : null}
                        <span style={{ cursor: "pointer" }} onClick={(e) => this.hsm_errors_open = !this.hsm_errors_open}>HSM Errors</span>
                    </div>);

            return (
                <div style={style}>
                    <div class="property-grid" style={{ display: "flex", flexDirection: "row", flexGrow: "0", flexShrink: "0", minHeight: "24px", background: "silver", alignItems: "center", gap: '5px' }}>
                        {header}
                    </div>
                    <div class="property-grid" style={{ display: "flex", flexDirection: "row", flexGrow: "0", flexShrink: "0", minHeight: "24px", maxHeight: "24px", background: "silver", alignItems: "center", gap: '5px' }}>
                        {outofdate}
                        {header2}
                        {utils.tt('Document customer ID ' + this.model.CustomerID, <QIcon name="mdi-information-outline" size="sm" />)}
                        <span>Revision:{revision_list} ({this.modify_UserName} @ {this.modify_DateTime})</span>
                        <span>{audit_history}{utils.tt('Open Change Log', <QBtn {...btnProps} icon="mdi-history" onClick={(e) => this.loadAuditHistory()} />)}</span>
                        {editing}
                        {this.getUserControlSettings()}
                        {[viewJsonChkbx, viewDesgnChkbx, navup]}
                    </div>

                    <ControlDesignerDockLayout
                        style={{ flex: 1, minHeight: 0 }}
                        showTree={this.showTree}
                        showCode={this.showCode}
                        showDesigner={this.showDesignerDock}
                        treeWidth={this.treeWidth}
                        loadLayout={this.getDockLayoutJson}
                        saveLayout={this.saveDockLayoutJson}
                        onDock-ready={this.onControlDesignerDockReady}
                    />

                    {jseditor}
                    {hsmerrors}
                    {this.renderLegacyCodeBehindPrompt()}
                </div>
            );
        }
        catch (err) {
            console.error('Error in ControlDesigner_v3', err);
            return <div>Error in ControlDesigner_v3: {err.message}</div>;
        }
    }
});

/*
 <PropertyGrid name={this.model.Name || this.model.MenuName} root={this} parentType="VerticalStack" schema={this.sel_schema} form={form} cmodel={this.sel_model} child={0} navigateToModel={this.navigateToModel}></PropertyGrid>

<div>
    name={this.model.Name || this.model.MenuName}<br />
    parentType="VerticalStack"<br />
    schema={JSON.stringify(this.sel_schema || {}, getCircularReplacer())}<br />
    form={JSON.stringify(form || [], getCircularReplacer())}<br />
    cmodel={JSON.stringify(this.sel_model || {}, getCircularReplacer())}<br />
    child={0}
</div>

*/